<div *ngIf="codigo?.length > 0; else templateVazio;"
     tooltip="Consultar Código de Receita"
     boundariesElement="viewport"
     container="body"
     [class.text-nowrap]="!(nome?.length > 0)"
     (click)='consultarCodigoReceita()'>
  <span class="link">{{ codigo }}</span>
  <span *ngIf="nome?.length > 0"> - {{ nome }}</span>
</div>

<ng-template #templateVazio>
  {{ '' | vazio }}
</ng-template>